// Copyright 2025 - Hewlett Packard Enterprise Company
import React from 'react';
import { Card, Box, Text } from 'grommet';
import PropTypes from 'prop-types';

const ChatQuestionButton = ({ question, onClick, ...rest }) => (
  <Card {...rest}>
    <Box
      pad="small"
      background="background-front"
      border={{
        color: 'border-weak',
        size: 'xsmall',
        style: 'solid',
      }}
      round="small"
      onClick={onClick}
      focusIndicator={false}
      hoverIndicator="background-back"
    >
      <Text size="small" weight="normal">
        {question}
      </Text>
    </Box>
  </Card>
);

ChatQuestionButton.propTypes = {
  question: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ChatQuestionButton;
